import EmailTypoModal from 'components/GlobalModals/EmailTypoModal/EmailTypoModal';
import { withEmailTypoModalProps } from 'viewModel/globalModals/emailTypoModal/withEmailTypoModalProps';

export default withEmailTypoModalProps(EmailTypoModal);
